/* AP — ap-drawer.js : tiroir panier natif (lot C). IIFE, zéro dépendance, defer. Interceptions en capture (avant theme.js
   Palo Alto), état embarqué #ApCartState puis /cart.js, compteur [data-header-cart-count], événements ap:cart:updated /
   ap:drawer:open / ap:drawer:close. API : window.ApDrawer = { open, close, add(variantId, qty), remove(lineKey), refresh(), cart(), waiver }
   Renonciation au droit de rétractation (snippet ap-waiver, tiroir + page /cart) : voir le bloc « renonciation » plus bas. */
(function () {
  'use strict';
  if (window.__apDrawerInit) return;
  window.__apDrawerInit = true;

  var root, panel, D, CART, TITLES, EDITIONS, UPG, UPS, R, OFFER = {};
  var busy = false, isOpen = false, synced = false, pending = false, trigger = null, toastTimer = 0;
  var WAIVER_KEY = 'Withdrawal waiver', WAIVER_MSG = 'Please tick the box above to continue.';
  var W = { accepted: false, seq: 0, saving: null, going: false, bypass: false };

  function noop() {}
  function q(s, c) { return (c || root).querySelector(s); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  function emit(name, detail) { try { document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail })); } catch (e) {} }
  function readJSON(sel, fb) { try { var el = q(sel); return el ? JSON.parse(el.textContent) : fb; } catch (e) { return fb; } }
  function autoOpen() { return D.autoOpen !== 'false'; }
  function items() { return (CART.items || []).filter(function (it) { return it.quantity > 0; }); }

  /* montage (rejoué par l'éditeur de thème sur shopify:section:load) */
  function bind() {
    root = document.getElementById('ApDrawer');
    if (!root) return false;
    panel = q('[data-apd-panel]'); D = root.dataset;
    CART = readJSON('#ApCartState', { items: [], item_count: 0, total_price: 0 });
    TITLES = readJSON('script[data-ap-titles]', {}); EDITIONS = readJSON('script[data-ap-editions]', {});
    UPG = readJSON('script[data-ap-upgrades]', {}); UPS = readJSON('script[data-ap-upsell]', []); OFFER = readJSON('script[data-ap-offer]', {});
    R = readJSON('script[data-ap-routes]', {});
    R.cart = R.cart || '/cart'; R.add = R.add || '/cart/add'; R.change = R.change || '/cart/change'; R.update = R.update || '/cart/update';
    if (!W.saving) W.accepted = acceptedIn(CART);
    if (isOpen) { root.classList.add('is-open'); panel.setAttribute('aria-hidden', 'false'); }
    fillOfferNotes();
    render();
    return true;
  }

  /* monnaie : window.theme.moneyFormat (Palo Alto) sans balises ni « ,00 » ; repli $x.xx ; code devise ajouté si ap-currency-code le demande (MXN) */
  function money(cents) {
    var fmt = String((window.theme && window.theme.moneyFormat) || '').replace(/<[^>]*>/g, '');
    if (fmt.indexOf('{{') < 0) fmt = '${{amount}}';
    var n = Math.abs(Number(cents) || 0) / 100;
    var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      var thou = /space/.test(k) ? ' ' : /apostrophe/.test(k) ? "'" : /comma_separator/.test(k) ? '.' : ',';
      var ds = /period/.test(k) ? '.' : /comma_separator|space_separator/.test(k) ? ',' : '.';
      var p = n.toFixed(/no_decimals/.test(k) ? 0 : 2).split('.');
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (p[1] ? ds + p[1] : '');
    }).replace(/([.,])00(?=\D*$)/, '');
    return (cents < 0 ? '-' : '') + out.trim() + ((window.theme && window.theme.apCurrencySuffix) || '');
  }
  function thumb(u, w) {
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return /[?&]width=/.test(u) ? u : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ouverture / fermeture / focus piégé */
  function focusables() {
    return [].slice.call(panel.querySelectorAll('a[href],button,input,select,textarea,[tabindex]')).filter(function (el) {
      return !el.disabled && el.getAttribute('tabindex') !== '-1' && (el.getAttribute('aria-disabled') !== 'true' || el.hasAttribute('data-waiver-locked')) && el.offsetParent !== null;
    });
  }
  function focusPanel() { try { panel.focus({ preventScroll: true }); } catch (e) {} }
  function flag(v) {
    isOpen = v;
    root.classList.toggle('is-open', v); document.body.classList.toggle('ap-drawer-open', v);
    panel.setAttribute('aria-hidden', v ? 'false' : 'true');
    var a = document.querySelectorAll('a.cart__toggle');
    for (var i = 0; i < a.length; i++) a[i].setAttribute('aria-expanded', v ? 'true' : 'false');
  }
  function open() {
    if (!root) return;
    if (!isOpen) trigger = document.activeElement;
    flag(true);
    if (!synced) { synced = true; refresh().catch(noop); }
    setTimeout(focusPanel, 20);
    emit('ap:drawer:open');
  }
  function close() {
    if (!isOpen) return;
    flag(false);
    if (trigger && trigger !== document.body && document.contains(trigger)) { try { trigger.focus({ preventScroll: true }); } catch (e) {} }
    trigger = null;
    emit('ap:drawer:close');
  }
  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    /* Tab géré entièrement (ordre DOM du panneau) : même comportement dans Safari, qui saute boutons et liens par défaut */
    e.preventDefault();
    var f = focusables(), i = f.indexOf(document.activeElement);
    if (!f.length) { focusPanel(); return; }
    f[i < 0 ? (e.shiftKey ? f.length - 1 : 0) : (i + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
  });
  document.addEventListener('focusin', function (e) {
    if (isOpen && !panel.contains(e.target) && !(e.target.closest && e.target.closest('#ApToast'))) focusPanel();
  });

  /* rendu */
  function lineTitle(it) { var ed = EDITIONS[it.product_id]; return (ed && ed.title) || TITLES[it.product_id] || it.product_title; }
  function lineMeta(it) {
    var p = [], ed = EDITIONS[it.product_id];
    if (it.variant_title && it.variant_title !== 'Default Title') p.push(it.variant_title.split(' / ').join(' · '));
    if (ed && ed.label) p.push(ed.label);
    (it.line_level_discount_allocations || []).forEach(function (d) { var t = d.discount_application && d.discount_application.title; if (t && p.indexOf(t) < 0) p.push(t); });
    return p.join(' · ');
  }
  function tbtn(attr, key, label) { return '<button type="button" class="apd-textbtn" ' + attr + '="' + esc(key) + '">' + esc(label) + '</button>'; }
  function renderItems(list) {
    var html = list.map(function (it) {
      var meta = lineMeta(it), disc = it.original_line_price > it.final_line_price;
      return '<div class="apd-item" data-key="' + esc(it.key) + '">' +
        '<div class="apd-item__media">' + (it.image ? '<img src="' + esc(thumb(it.image, 160)) + '" width="64" height="80" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="apd-item__info"><p class="apd-item__title">' + esc(lineTitle(it)) + '</p>' + (meta ? '<p class="apd-item__meta">' + esc(meta) + '</p>' : '') + '</div>' +
        '<div class="apd-item__price">' + esc(it.final_line_price === 0 ? D.labelFree : money(it.final_line_price)) + (disc ? '<s class="apd-item__compare">' + esc(money(it.original_line_price)) + '</s>' : '') + '</div>' +
        '<div class="apd-item__actions">' + (it.quantity > 1 ? '<span class="apd-item__qty">× ' + it.quantity + '</span>' + tbtn('data-ap-setone', it.key, D.labelSetone) : '') + tbtn('data-ap-remove', it.key, D.labelRemove) + '</div></div>';
    }).join('');
    if (pending) html += '<div class="apd-item apd-item--pending" aria-busy="true"><div class="apd-item__media"></div><div class="apd-item__info"><span class="apd-item__skel"></span><span class="apd-item__skel"></span><p class="apd-item__meta">' + esc(D.labelAdding) + '</p></div></div>';
    q('[data-apd-items]').innerHTML = html;
    q('[data-apd-empty]').hidden = list.length > 0 || pending;
  }
  function renderUpgrade(list) {
    var box = q('[data-apd-upgrade]'); if (!box) return;
    var pick = null;
    for (var i = 0; i < list.length && !pick; i++) {
      var u = UPG[list[i].variant_id];
      if (u && u.available && !list.some(function (x) { return x.product_id === u.pro_product_id; })) pick = { line: list[i], u: u };
    }
    box.hidden = !pick;
    if (!pick) return;
    var diff = (pick.u.diff_cents > 0 ? '+' : '') + money(pick.u.diff_cents);
    function tpl(s) { return (s || '').split('{diff}').join(diff); }
    q('[data-apd-upgrade-title]', box).textContent = tpl(box.dataset.title);
    q('[data-apd-upgrade-text]', box).textContent = tpl(box.dataset.text);
    var b = q('[data-apd-upgrade-btn]', box);
    b.textContent = tpl(box.dataset.button); b.setAttribute('data-ap-upgrade', pick.line.key);
  }
  /* remise de l'offre groupée : o.off est en cents USD (devise de la boutique), converti au taux du marché comme la remise automatique au panier */
  function offerOff(o) {
    var rate = Number(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    return Math.round(o.off * rate);
  }
  /* offre groupée : prix réduit affiché quand un produit déclencheur est dans le panier (la remise automatique fait le calcul au panier) */
  function upsellPrice(p, list) {
    var o = OFFER || {}, buy = o.buy || [];
    if (o.get === p.id && o.off > 0 && list.some(function (it) { return buy.indexOf(it.product_id) > -1; })) {
      return '<s class="apd-uc__compare">' + esc(money(p.price)) + '</s> ' + esc(money(Math.max(0, p.price - offerOff(o)))) + (o.note ? '<span class="apd-uc__note">' + esc(o.note) + '</span>' : '');
    }
    return esc(p.price === 0 ? D.labelFree : money(p.price));
  }
  /* note de l'offre sur les fiches gabarits (sections/ap-product.liquid, data-ap-offer-note) : montants dans la devise du visiteur, puis affichage */
  function fillOfferNotes() {
    var o = OFFER || {};
    if (!(o.off > 0 && o.price > 0)) return;
    var pp = Math.max(0, o.price - offerOff(o));
    [].slice.call(document.querySelectorAll('[data-ap-offer-note]')).forEach(function (n) {
      var v = { compare: o.price, price: pp, total: (Number(n.getAttribute('data-tpl')) || 0) + pp };
      [].slice.call(n.querySelectorAll('[data-ap-offer]')).forEach(function (s) { s.textContent = money(v[s.getAttribute('data-ap-offer')]); });
      n.hidden = false;
    });
  }
  function renderUpsell(list) {
    var box = q('[data-apd-upsell]'); if (!box) return;
    var inCart = {}; list.forEach(function (it) { inCart[it.product_id] = 1; });
    var picks = UPS.filter(function (p) { return p.available && !inCart[p.id]; }).slice(0, 3);
    box.hidden = !picks.length || !list.length;
    if (box.hidden) return;
    var grid = q('[data-apd-upsell-grid]', box);
    grid.className = 'apd-upsell__grid' + (picks.length === 1 ? ' is-single' : '');
    grid.innerHTML = picks.map(function (p) {
      return '<div class="apd-uc" data-product-id="' + esc(p.id) + '"><a class="apd-uc__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + (p.img ? '<img src="' + esc(thumb(p.img, 240)) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="apd-uc__body"><a class="apd-uc__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a><span class="apd-uc__price">' + upsellPrice(p, list) + '</span></div>' +
        '<button type="button" class="ap-btn ap-btn--secondary ap-btn--xs ap-btn--block" data-ap-add="' + esc(p.vid) + '">' + esc(D.labelAdd) + '</button></div>';
    }).join('');
  }
  function renderFoot(list) {
    var n = CART.item_count || 0, apps = CART.cart_level_discount_applications || [], disc = q('[data-apd-discounts]');
    q('[data-apd-count]').textContent = n + ' ' + (n === 1 ? D.labelOne : D.labelMany);
    disc.innerHTML = apps.map(function (a) { return '<div class="apd-discount"><span>' + esc(a.title) + '</span><span>−' + esc(money(a.total_allocated_amount)) + '</span></div>'; }).join('');
    disc.hidden = !apps.length;
    var total = list.length && CART.total_price === 0 ? D.labelFree : money(CART.total_price), co = q('[data-ap-checkout]');
    q('[data-apd-subtotal]').textContent = total;
    q('[data-apd-checkout-label]').textContent = D.checkoutLabel + (list.length ? ' · ' + total : '');
    co.setAttribute('aria-disabled', list.length && W.accepted ? 'false' : 'true');
    if (list.length) co.removeAttribute('tabindex'); else co.setAttribute('tabindex', '-1');
    q('[data-apd-foot]').hidden = !list.length;
  }
  function syncHeader() {
    var n = CART.item_count || 0, i, c = document.querySelectorAll('[data-header-cart-count]'), a = document.querySelectorAll('a.cart__toggle');
    for (i = 0; i < c.length; i++) { c[i].textContent = n; c[i].dataset.cartCount = n; c[i].hidden = n === 0; }
    for (i = 0; i < a.length; i++) a[i].classList.toggle('cart-toggle-has-items', n > 0);
  }
  function render() {
    var list = items();
    renderItems(list); renderUpgrade(list); renderUpsell(list); renderFoot(list); syncHeader(); applyWaiver();
    var live = q('[data-apd-live]'); if (live) live.textContent = q('[data-apd-count]').textContent;
  }

  /* API panier */
  function parse(r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw j; return j; }); }
  function req(url, body) {
    return fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } }).then(parse);
  }
  function setCart(c) { if (c && c.items) { CART = c; if (!W.saving) W.accepted = acceptedIn(c); render(); emit('ap:cart:updated', c); } return c; }
  function refresh() { return req(R.cart + '.js').then(setCart); }
  function setBusy(b) { busy = b; root.classList.toggle('is-busy', b); }
  function done() { setBusy(false); }
  function fail(msg) { return function (e) { pending = false; setBusy(false); render(); refresh().catch(noop); toast((e && e.description) || msg, { error: true }); }; }
  function afterAdd() { if (autoOpen()) open(); else if (!isOpen) toast(D.toastAdded, { view: true }); }

  function add(id, qty) {
    if (busy) return Promise.resolve();
    setBusy(true);
    return req(R.add + '.js', { items: [{ id: Number(id), quantity: qty || 1 }] }).then(refresh).then(function () { done(); afterAdd(); }).catch(fail(D.errorAdd));
  }
  function addForm(form) {
    if (busy) return;
    setBusy(true); pending = true;
    if (autoOpen()) { render(); open(); }
    fetch(R.add + '.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } }).then(parse).then(refresh)
      .then(function () { pending = false; done(); render(); if (!autoOpen()) toast(D.toastAdded, { view: true }); }).catch(fail(D.errorAdd));
  }
  function change(key, qty) {
    if (busy) return Promise.resolve();
    setBusy(true);
    return req(R.change + '.js', { id: key, quantity: qty }).then(setCart).then(done).catch(fail(D.errorUpdate));
  }
  /* upgrade Template → Pro : ajout du Pro d'abord, puis retrait du Template (un échec d'ajout ne vide jamais le panier) */
  function upgrade(key) {
    if (busy) return;
    var line = items().filter(function (it) { return it.key === key; })[0], u = line && UPG[line.variant_id];
    if (!u) return;
    setBusy(true);
    req(R.add + '.js', { items: [{ id: Number(u.pro_variant_id), quantity: 1 }] })
      .then(function () { return req(R.change + '.js', { id: key, quantity: 0 }); }).then(refresh).then(done).catch(fail(D.errorUpdate));
  }

  /* ---------- renonciation au droit de rétractation (contenus numériques, UE) ----------
     Case [data-ap-waiver] (snippet ap-waiver) dans le tiroir et sur /cart, non cochée par défaut.
     Cochée → attribut de panier « Withdrawal waiver » = « Accepted <date ISO> » (POST /cart/update.js) ; décochée → attribut effacé.
     L'état vient de cart.attributes : il survit à la fermeture du tiroir et au rechargement.
     Tant qu'elle n'est pas cochée : bouton du tiroir [data-ap-checkout], bouton name="checkout" de /cart, liens /checkout
     et boutons express [data-additional-checkout-button] verrouillés (aria-disabled + data-waiver-locked, clic / clavier
     interceptés, message d'aide). Cochée : l'attribut est confirmé côté serveur AVANT de partir au checkout.
     Sans case dans la page (réglage « waiver_required » décoché, cas par défaut depuis le 27.10.2026) : rien n'est
     verrouillé et l'attribut n'est pas écrit. */
  function waiverFromCart(c) { var v = c && c.attributes && c.attributes[WAIVER_KEY]; return typeof v === 'string' && v.indexOf('Accepted') === 0; }
  function waiverOn() { return !!document.querySelector('[data-ap-waiver-input]'); }
  function acceptedIn(c) { return !waiverOn() || waiverFromCart(c); }
  function all(sel) { return [].slice.call(document.querySelectorAll(sel)); }
  function pageCheckouts() { return all('form[action$="/cart"] [name="checkout"], [data-ap-page-checkout]'); }
  function lockEl(el, locked) {
    if (locked) { el.setAttribute('aria-disabled', 'true'); el.setAttribute('data-waiver-locked', ''); }
    else { el.removeAttribute('data-waiver-locked'); if (el.hasAttribute('data-ap-checkout')) el.setAttribute('aria-disabled', items().length ? 'false' : 'true'); else el.removeAttribute('aria-disabled'); }
  }
  function applyWaiver() {
    var on = W.accepted, val = (CART && CART.attributes && CART.attributes[WAIVER_KEY]) || '';
    all('[data-ap-waiver-input]').forEach(function (i) { i.checked = on; });
    all('[data-ap-waiver-field]').forEach(function (f) { if (!W.saving) f.value = on ? (waiverFromCart(CART) ? val : f.value) : ''; });
    if (on) all('[data-ap-waiver]').forEach(function (b) { b.classList.remove('is-error'); var h = b.querySelector('[data-ap-waiver-help]'); if (h) h.textContent = ''; });
    all('[data-ap-checkout]').forEach(function (el) { lockEl(el, !on); });
    /* /cart : « disabled » posé côté serveur (rien ne part avant ce script) → remplacé par aria-disabled pour garder le message d'aide */
    pageCheckouts().forEach(function (el) { el.disabled = false; lockEl(el, !on); });
    all('[data-additional-checkout-button]').forEach(function (el) { el.hidden = !on; if (!on) el.setAttribute('inert', ''); else el.removeAttribute('inert'); });
  }
  function setWaiver(on) {
    var seq = ++W.seq, val = on ? 'Accepted ' + new Date().toISOString() : '', attrs = {};
    attrs[WAIVER_KEY] = val;
    W.accepted = on;
    all('[data-ap-waiver-field]').forEach(function (f) { f.value = val; });
    applyWaiver();
    var p = req(R.update + '.js', { attributes: attrs }).then(function (c) {
      if (seq === W.seq) { W.saving = null; setCart(c); }
      return c;
    }, function (e) {
      if (seq === W.seq) W.saving = null;
      throw e;
    });
    W.saving = p;
    return p;
  }
  /* attribut confirmé par le serveur juste avant le départ (écriture en cours attendue ; panier relu, car la page peut venir
     du cache de l'historique ; attribut réécrit s'il manque, la case étant cochée à l'écran) */
  function ensureWaiver() {
    if (!waiverOn()) return Promise.resolve(true);
    return (W.saving || Promise.resolve()).catch(noop).then(function () { return req(R.cart + '.js'); }).then(function (c) {
      if (waiverFromCart(c)) { setCart(c); return true; }
      return setWaiver(true).then(function () { return waiverFromCart(CART); });
    });
  }
  function waiverBox(src) {
    var inDrawer = src && src.closest && src.closest('#ApDrawer'), box = null;
    if (!inDrawer) box = all('[data-ap-waiver]').filter(function (b) { return !b.closest('#ApDrawer') && b.offsetParent !== null; })[0] || null;
    if (!box) { box = root.querySelector('[data-ap-waiver]'); if (!isOpen) open(); }
    return box;
  }
  function waiverBlocked(src) {
    var box = waiverBox(src); if (!box) return;
    var help = box.querySelector('[data-ap-waiver-help]'), input = box.querySelector('[data-ap-waiver-input]');
    box.classList.remove('is-error'); void box.offsetWidth; box.classList.add('is-error');
    if (help) { help.textContent = ''; help.textContent = box.getAttribute('data-error') || WAIVER_MSG; }
    var inDrawer = !!box.closest('#ApDrawer');
    if (input) setTimeout(function () {
      try { input.focus({ preventScroll: true }); } catch (e) {}
      if (!inDrawer && input.scrollIntoView) { var r = input.getBoundingClientRect(); if (r.top < 80 || r.bottom > window.innerHeight - 40) input.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
    }, inDrawer && !isOpen ? 300 : 30);
  }
  function goCheckout(go) {
    if (W.going) return;
    W.going = true; setBusy(true);
    ensureWaiver().then(function (ok) { if (!ok) throw 0; go(); }).catch(function () { W.going = false; setBusy(false); toast(D.errorUpdate, { error: true }); });
  }
  function submitPageCheckout(btn) {
    var f = btn.form;
    W.bypass = true; btn.disabled = false; btn.removeAttribute('aria-disabled'); btn.removeAttribute('data-waiver-locked');
    if (f.requestSubmit) { f.requestSubmit(btn); return; }
    var h = document.createElement('input'); h.type = 'hidden'; h.name = 'checkout'; h.value = '1'; f.appendChild(h); f.submit();
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!root || !t || !t.matches || !t.matches('[data-ap-waiver-input]')) return;
    setWaiver(t.checked).catch(function () { toast(D.errorUpdate, { error: true }); });
  });
  /* retour arrière depuis le checkout (bfcache) : déverrouiller l'interface et relire le panier ;
     page resservie par le cache de l'historique (état embarqué périmé) : relire le panier */
  window.addEventListener('pageshow', function (e) { if (e.persisted && root) { W.going = false; W.bypass = false; setBusy(false); refresh().catch(noop); } });
  function staleHistoryLoad() { try { var n = performance.getEntriesByType('navigation')[0]; return !!n && n.type === 'back_forward'; } catch (e) { return false; } }

  /* toast 5 s */
  function toast(msg, o) {
    o = o || {};
    var old = document.getElementById('ApToast'); if (old) old.remove();
    clearTimeout(toastTimer);
    var el = document.createElement('div');
    el.id = 'ApToast'; el.className = 'apd-toast' + (o.error ? ' apd-toast--error' : ''); el.setAttribute('role', 'status');
    el.innerHTML = '<span>' + esc(msg) + '</span>' + (o.view ? '<button type="button" data-ap-toast-view>' + esc(D.toastView) + '</button>' : '');
    el.addEventListener('click', function (ev) { if (ev.target.closest('[data-ap-toast-view]')) { el.remove(); open(); } });
    document.body.appendChild(el);
    toastTimer = setTimeout(function () { el.remove(); }, 5000);
  }

  /* interceptions globales en capture (actives avant theme.js) */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.tagName === 'FORM' && /\/cart\/add/.test(f.getAttribute('action') || '')) { e.preventDefault(); e.stopImmediatePropagation(); addForm(f); return; }
    /* /cart : envoi « checkout » sans clic intercepté (requestSubmit d'un autre script, etc.) → même contrôle */
    if (f && f.tagName === 'FORM' && /\/cart\/?$/.test(f.getAttribute('action') || '') && !W.bypass && root) {
      var s = e.submitter;
      if (s && s.name === 'checkout') { e.preventDefault(); e.stopImmediatePropagation(); if (!W.accepted) waiverBlocked(s); else goCheckout(function () { submitPageCheckout(s); }); }
    }
  }, true);
  document.addEventListener('click', function (e) {
    var t = e.target, el;
    if (!t || !t.closest) return;
    if (t.closest('[data-ap-close]')) { e.preventDefault(); close(); return; }
    if ((el = t.closest('[data-ap-add]'))) { e.preventDefault(); if (!busy) { el.disabled = true; el.textContent = D.labelAdding; add(el.getAttribute('data-ap-add')); } return; }
    if ((el = t.closest('[data-ap-remove]'))) { e.preventDefault(); change(el.getAttribute('data-ap-remove'), 0); return; }
    if ((el = t.closest('[data-ap-setone]'))) { e.preventDefault(); change(el.getAttribute('data-ap-setone'), 1); return; }
    if ((el = t.closest('[data-ap-upgrade]'))) { e.preventDefault(); upgrade(el.getAttribute('data-ap-upgrade')); return; }
    if ((el = t.closest('[data-ap-checkout]'))) {
      e.preventDefault();
      if (busy || !items().length) return;
      if (!W.accepted) { waiverBlocked(el); return; }
      goCheckout(function () { window.location.href = '/checkout'; }); return;
    }
    /* /cart : bouton name="checkout" ; partout : liens vers /checkout */
    if ((el = t.closest('form[action$="/cart"] [name="checkout"], [data-ap-page-checkout], a[href$="/checkout"], a[href*="/checkout?"]'))) {
      if (W.bypass || !root) return; /* sans tiroir (jamais le cas : layout) le bouton de /cart reste « disabled » côté serveur */
      e.preventDefault(); e.stopImmediatePropagation();
      if (!W.accepted) { waiverBlocked(el); return; }
      if (el.tagName === 'A') goCheckout(function () { window.location.href = el.href; });
      else goCheckout(function () { submitPageCheckout(el); });
      return;
    }
    /* bouton d'achat d'un formulaire produit : on gagne la course contre le listener document de Palo Alto */
    if ((el = t.closest('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] [name="add"], form[action*="/cart/add"] [data-add-to-cart]'))) {
      if (el.disabled || el.getAttribute('aria-disabled') === 'true') return;
      e.preventDefault(); e.stopImmediatePropagation(); addForm(el.closest('form')); return;
    }
    if ((el = t.closest('[data-add-to-cart][data-product-id]'))) { e.preventDefault(); e.stopImmediatePropagation(); add(el.getAttribute('data-product-id')); return; }
    /* icône / liens panier → tiroir (clic modifié = navigation normale) */
    if (t.closest('a.cart__toggle, a[href="/cart"], a[href$="/cart"], [data-cart-drawer-toggle]')) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault(); e.stopImmediatePropagation(); open();
    }
  }, true);

  /* filet universel : tout POST /cart/add réussi hors moteur (apps, autres scripts) → rafraîchir + ouvrir */
  (function () {
    var _fetch = window.fetch; if (!_fetch) return;
    window.fetch = function (u, o) {
      var pr = _fetch.apply(this, arguments);
      try {
        var url = String((u && u.url) || u || ''), method = ((o && o.method) || (u && u.method) || 'GET').toUpperCase();
        if (method === 'POST' && /\/cart\/add(\.js)?([?#]|$)/.test(url) && !busy) pr.then(function (r) { if (r && r.ok) refresh().then(afterAdd).catch(noop); }).catch(noop);
      } catch (x) {}
      return pr;
    };
  })();

  /* éditeur de thème */
  function owns(e) { return !!(e.target && e.target.querySelector && e.target.querySelector('#ApDrawer')); }
  document.addEventListener('shopify:section:load', function (e) { if (owns(e)) bind(); });
  document.addEventListener('shopify:section:select', function (e) { if (owns(e)) open(); });
  document.addEventListener('shopify:section:deselect', function (e) { if (owns(e)) close(); });

  if (!bind()) return;
  if (staleHistoryLoad()) refresh().catch(noop);
  window.ApDrawer = { open: open, close: close, add: add, remove: function (key) { return change(key, 0); }, refresh: refresh, cart: function () { return CART; },
    waiver: { accepted: function () { return W.accepted; }, set: setWaiver } };
})();
